<template>
    <section class="messages-inner">
        <!-- <div style="white-space: nowrap; overflow: hidden">{{ image }}</div> -->
        <div
            v-if="loader"
            class="messages-empty"
        ><button class="button-loader"></button></div>
        <div
            v-else-if="!messagesIsEmpty('messages')"
            class="messages-chat"
        >
            <div
                class="messages-chat-inner"
            >
                <div v-bar class="messages-scrollbar-container" id="messagesBar">
                    <div
                        class="messages-scrollbar-content"
                        id="scrollToBottom"
                    >
                        <div
                            class="messages-scrollbar-scroller"
                            id="longEl"
                        >
                            <div
                                v-if="moreLoader"
                                class="messages-loader-wrapper"
                            >
                                <button class="button-loader"></button>
                            </div>
                            <div
                                v-for="(message, index) in messages"
                                :ref="'message' + message.id"
                                :id="'message' + message.id"
                                :key="message.id"
                                class="messages-item"
                                :class="{
                                    'messages-item-me': message.sender.id == user.id,
                                    'messages-item-first': checkDate(index),
                                    'messages-item-group': message.sender.id != user.id && currentThread.isGroup,
                                    'messages-item-new': message.read === 0
                                }"
                            >
                                <div
                                    v-if="checkDate(index)"
                                    class="messages-time-divider"
                                >{{ getVerbalDay(message.time) }}</div>
                                <div
                                    v-if="message.sender.id != user.id && currentThread.isGroup"
                                    :style="{ 'background-image': message.sender.avatar ? 'url(' + message.sender.avatar + ')' : '' }"
                                    class="messages-item-avatar"
                                ></div>
                                <messageContext
                                    :id="message.id"
                                    :my="message.sender.id == user.id"
                                ></messageContext>
                                <div class="messages-item-text">{{ message.text }}</div>
                                <div
                                    v-if="message.image"
                                    @click="$modal.show('image-details', {image: message.image})"
                                    :style="{ 'background-image': 'url(' + message.image + ')' }"
                                    class="messages-item-image"
                                >

                                </div>
                                <div class="messages-item-time">{{ getHM(message.time) }}</div>
                            </div>
                            <div
                                v-if="morePrevLoader"
                                class="messages-prev-loader-wrapper"
                            >
                                <button class="button-loader"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-else
            class="messages-empty"
        > {{ $t("threads.hereMessages") }}</div>
        <div
            v-if="currentThread.vip"
            class="messages-vip"
        >
            <div class="messages-vip-text">
                {{ $t("threads.youCannotWriteUser") }}<br>
                {{ $t("threads.accessFriendsVip") }}
            </div>
            <button
                @click="$modal.show('vip-buy')"
                class="button"
            >{{ $t("threads.buyVipStatus") }}</button>
        </div>
        <div
            v-else-if="currentThread.blacklist"
            class="messages-vip"
        >
            <div class="messages-vip-text">
               {{ $t("threads.userPrivateMessages") }}
            </div>
        </div>
        <form
            v-else
            class="messages-form"
            data-vv-scope="newMessageForm"
            @submit.prevent="sendMessage('newMessageForm')"
        >
            <div class="messages-form-uploads">
                <div
                    v-if="instanceLoader"
                    class="messages-form-loader loader"
                ></div>
                <div
                    v-else-if="image"
                    class="messages-form-images"
                    :style="{ 'background-image': 'url(' + image + ')' }"
                >
                    <div
                        class="messages-delete-image"
                        @click="deleteImage('image')"
                        v-if="image"
                    ></div>
                </div>
                <div
                    v-else-if="instanceError"
                    class="messages-form-loader messages-form-error"
                >
                    <div
                        class="messages-delete-image"
                        @click="instanceError = false"
                    ></div>
                    <span>{{ $t("threads.errorLoadingImage") }}</span>
                </div>
            </div>
            <div class="messages-form-row">
                <textarea
                    v-model="text"
                    name="text"
                    v-validate="'required|min:2'"
                    class="textarea-hidden"
                ></textarea>
                <div
                    @keydown.enter.exact.prevent
                    @keyup.enter.exact="sendMessage('newMessageForm')"
                    @keyup.enter.ctrl.exact="sendMessage('newMessageForm')"
                    @keydown.enter.shift.exact="newline"
                    ref="pseudotextarea"
                    class="textarea messages-textarea"
                    contenteditable="true"
                ></div>
                <label
                    for="image"
                    class="messages-attach"
                ></label><br>
                <input
                    type="file"
                    accept="image/*"
                    id="image"
                    name="image"
                    @change="addImage($event, 'image')"
                    v-validate="'size:10000|ext:jpeg,jpg,png,gif'"
                    data-vv-as="file"
                    class="input-hidden"
                >
                <div class="v-error">{{ errors.first('newMessageForm.image') }}</div>
                <div
                    @click="toggleEmoji"
                    ref="emojiOpener"
                    class="messages-emoji-opener"
                ></div>
                <ul
                    v-if="showEmoji"
                    v-click-outside="{
                        exclude: ['emojiOpener'],
                        handler: 'clickOutsideEmoji'
                    }"
                    class="messages-emoji"
                >
                    <li
                        v-for="emoji in consts.emoji"
                        @click="addEmoji(emoji)"
                        class="messages-emoji-item"
                        :key="emoji"
                    >{{ emoji }}</li>
                </ul>
                <button
                    type="submit"
                    class="button messages-send"
                ></button>
            </div>
        </form>
    </div>
    <div
        v-else
        class="messages-body messages-empty info-block"
    >
    {{ $t("threads.hereMessages") }}
    </div>
    </section>
</template>

<script>
import { mapGetters } from "vuex";
import messageContext from "@/components/Blocks/MessageContext";
import { formatDateTime } from "@/mixins/formatDateTime";
import { uploadImage } from "@/mixins/uploadImage";
import { observeListEnd } from "@/mixins/observeListEnd";
import { scrollToBottom } from "@/mixins/scrollToBottom";
import { consts } from "@/consts";
import { clickOutside } from "@/directives.js";
import Vue from "vue";

export default {
  name: "MessagesBlock",
  props: {
    currentThread: {
      type: Object,
      required: true,
      i18n: Object,
    },
    onMessageSent: {
      type: Function,
      required: true,
    },
  },
  components: {
    messageContext,
  },
  mixins: [formatDateTime, uploadImage, observeListEnd, scrollToBottom],
  data() {
    return {
      loader: true,
      text: "",
      image: "",
      sendMessageLoader: false,
      moreLoader: false,
      morePrevLoader: false,
      moreIndex: 0,
      morePrevIndex: 0,
      observer: null,
      observerPrev: null,
      height: "auto",
      wrapper: null,
      showEmoji: false,
      consts: consts,
      instanceLoader: false,
      instanceError: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "user/fetchUser",
      messagesIsEmpty: "messages/isEmpty",
      messages: "messages/fetchMessages",
      nextMessages: "messages/fetchMessagesNext",
      prevMessages: "messages/fetchMessagesPrev",
      activeThread: "messages/fetchActiveThread",
      newCount: "messages/fetchMessagesNewCount",
      init: "init/fetchInit",
    }),
    messageThread() {
      return this.$store.getters["threads/fetchThreadById"](
        parseInt(this.messageThreadId)
      );
    },
  },
  created() {
    let self = this;
    this.observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting === true) {
          self.showMoreMessages();
        }
      },
      { threshold: [0] }
    );
    this.observerPrev = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting === true) {
          self.showMorePrevMessages();
        }
      },
      { threshold: [0] }
    );
    this.getMessages();
    let msie = window.document.documentMode;
    setTimeout(() => {
      let textarea = this.$refs.pseudotextarea;
      if (!textarea) {
        return;
      }
      if (msie) {
        textarea.addEventListener("keydown", this.onKeydown);
      } else {
        textarea.addEventListener("input", this.onKeydown);
      }
    }, 500);
  },
  watch: {
    activeThread() {
      this.loader = true;
      this.observeListEnd("message", false, true);
      this.getMessages();
    },
    "currentThread.message"() {
      this.loader = true;
      this.observeListEnd("message", false, true);
      this.getMessages();
    },
  },
  methods: {
    onKeydown(e) {
      let self = this;
      setTimeout(function () {
        self.onInput.call(this, e);
      });
    },
    onInput(e) {
      let trim = e.target.textContent.trim();
      let value = e.target.innerText;
      if (e.target.lastValue == trim) {
        return;
      }
      e.target.lastValue = trim;
      this.text = value;
    },
    newline() {
      this.text = `${this.text}\n`;
    },
    getMessages() {
      if (!this.activeThread) {
        this.$store.dispatch("messages/getEmptyMessages");
        return;
      }
      if (this.currentThread.message) {
        this.$store
          .dispatch("messages/getByPage", {
            id: this.currentThread.id,
            page: this.currentThread.message.page,
          })
          .then(() => {
            this.loader = false;
            if (!this.messagesIsEmpty("messages")) {
              setTimeout(() => {
                document.getElementById("scrollToBottom").scrollTop =
                  this.$refs[
                    "message" + this.currentThread.message.id
                  ][0].offsetTop;

                if (this.messages.length > 2) {
                  this.updateMoreIndex();
                  this.updateMorePrevIndex();
                  this.observeListEnd("message", false);
                  this.observeListStart("message", false);
                } else {
                  this.observeListEnd("message", false, true);
                  this.observeListStart("message", false, true);
                }
                this.decrementCounters();
              }, 200);
            }
          })
          .catch(() => {
            this.loader = false;
          });
      } else {
        this.$store
          .dispatch("messages/getMessages", this.activeThread)
          .then(() => {
            this.loader = false;
            if (!this.messagesIsEmpty("messages")) {
              //decrement thread counter
              //decrement common counter
              setTimeout(() => {
                this.scrollToBottom();
                if (this.messages.length > 2) {
                  this.updateMoreIndex();
                  this.observeListEnd("message", false);
                } else {
                  this.observeListEnd("message", false, true);
                }
                this.decrementCounters();
              }, 200);
            }
          })
          .catch(() => {
            this.loader = false;
          });
      }
    },
    decrementCounters() {
      this.decrementCommonCounter();
      this.decrementThreadCounter();
    },
    decrementCommonCounter() {
      if (this.init.counters.messages == 0) {
        return;
      }
      this.$store.dispatch("init/setCounters", {
        counter: "messages",
        increment: true,
        count: -1 * this.newCount,
      });
    },
    decrementThreadCounter() {
      if (this.currentThread.new_messages_count == 0) {
        return;
      }
      this.$store.dispatch("threads/setNewMessages", {
        id: this.currentThread.id,
        increment: true,
        count: -1 * this.newCount,
      });
    },
    sendMessage(scope) {
      this.$validator.validateAll(scope).then((valid) => {
        if (valid) {
          if (this.sendMessageLoader) {
            return;
          }
          this.sendMessageLoader = true;
          let tempText = this.text;
          setTimeout(() => {
            this.scrollToBottom();
            this.text = "";
            this.$refs.pseudotextarea.innerText = "";
            this.$refs.pseudotextarea.focus();
            this.image = "";
            this.errors.clear();
            this.$validator.reset();
            this.sendMessageLoader = false;
            this.showEmoji = false;
          }, 100);
          const data = { text: this.text };
          if (this.image) {
            data.image = this.image;
          }
          let id, url, payload;
          if (this.currentThread.id) {
            url = "messages/createMessage";
            payload = {
              id: this.currentThread.id,
              user: this.user,
              data: data,
            };
          } else {
            url = "messages/createDialog";
            payload = {
              id: this.currentThread.interlocutor.id,
              user: this.user,
              data: data,
            };
          }
          this.$store
            .dispatch(url, payload)
            .then(() => {
              this.$store.dispatch("threads/setNewMessages", {
                id: this.currentThread.id,
                text: tempText,
                senderId: this.user.id,
              });
              if (!this.currentThread.id) {
                // TODO: возможно, стоит заменить на $emit
                this.onMessageSent();
              }
            })
            .catch((err) => {
              this.sendMessageLoader = false;
            });
        }
      });
    },
    checkDate(index) {
      let message = this.messages[index];
      let prevMessage = this.messages[index - 1];

      let match = false;

      if (
        !prevMessage ||
        this.getDMY(prevMessage.time) != this.getDMY(message.time)
      ) {
        match = true;
      }

      return match;
    },
    updateMoreIndex() {
      this.moreIndex = this.messages[2].id;
    },
    updateMorePrevIndex() {
      this.morePrevIndex = this.messages[this.messages.length - 2].id;
    },
    showMoreMessages() {
      let oldHeight = document.getElementById("longEl").offsetHeight;

      if (this.nextMessages) {
        this.moreLoader = true;
        this.$store
          .dispatch("messages/getNext")
          .then(() => {
            document.getElementById("scrollToBottom").scrollTop +=
              document.getElementById("longEl").offsetHeight - oldHeight;

            this.moreLoader = false;
            this.decrementCounters();
          })
          .catch(() => {
            this.moreLoader = false;
          });
      } else {
        // this.observeListEnd('message', false, true);
      }
    },
    showMorePrevMessages() {
      if (this.prevMessages) {
        this.morePrevLoader = true;
        this.$store
          .dispatch("messages/getPrev")
          .then(() => {
            this.morePrevLoader = false;
            // this.updateMorePrevIndex();
            this.observeListStart("message", false, true, true);
            this.decrementCounters();
          })
          .catch(() => {
            this.morePrevLoader = false;
          });
      } else {
        this.observeListStart("message", false, true);
      }
    },
    addEmoji(emoji) {
      this.text += emoji;
      this.$refs.pseudotextarea.innerHTML += emoji;
      this.placeCaretAtEnd(this.$refs.pseudotextarea);
    },
    toggleEmoji() {
      this.showEmoji = !this.showEmoji;
    },
    clickOutsideEmoji() {
      this.showEmoji = false;
    },
    placeCaretAtEnd(el) {
      el.focus();
      if (
        typeof window.getSelection != "undefined" &&
        typeof document.createRange != "undefined"
      ) {
        let range = document.createRange();
        range.selectNodeContents(el);
        range.collapse(false);
        let sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      } else if (typeof document.body.createTextRange != "undefined") {
        let textRange = document.body.createTextRange();
        textRange.moveToElementText(el);
        textRange.collapse(false);
        textRange.select();
      }
    },
  },
};
</script>

<!-- <style lang="scss" scoped>
    @import '~@/assets/styles/pages/_messages';
</style> -->
